<template>
  <div class="job-page">
    <!-- 筛选栏 -->
    <div class="select-row">
      <div class="select-box">
        <el-select
          v-model="selectedSecond"
          placeholder="请选择企业"
          clearable
        >
          <el-option label="全部企业" value="" />
          <el-option
            v-for="item in secondOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <!-- 替换：岗位类型 → 工作地点 -->
      <div class="select-box">
        <el-select
          v-model="selectedLocation"
          placeholder="请选择工作地点"
          clearable
        >
          <el-option label="全部工作地点" value="" />
          <el-option
            v-for="item in locationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <div class="select-box">
        <el-select
          v-model="selectedEdu"
          placeholder="请选择学历要求"
          clearable
        >
          <el-option label="全部学历" value="" />
          <el-option
            v-for="item in eduOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <!-- 岗位列表：卡片点击跳转，详情合并折叠 -->
    <div class="job-list">
      <div
        class="job-item"
        v-for="job in filteredJobs"
        :key="job.id"
        @click="goLink(job.url)"
      >
        <div class="job-header">
          <div class="job-name">{{ job.name }}</div>
        </div>
        
        <!-- 企业名称：有值才显示二级-三级，否则只显示二级 -->
        <div class="job-company">
          {{ job.secondCompany }}
          <span v-if="job.third"> - {{ job.third }}</span>
        </div>

        <div class="job-info">
          <span class="info-item">📍 {{ job.location }}</span>
          <span class="info-item">📚 {{ job.education }}</span>
          <span class="info-item">👥 需求{{ job.needNum }}人</span>
          <span class="info-item">📌 {{ job.jobType }}</span>
        </div>

        <!-- 合并：岗位描述 + 任职要求 + 薪酬，一起折叠 -->
        <div class="desc-block" @click.stop="toggleDetail(job.id)">
          <div class="desc-title">
            查看详情
            <i class="arrow" :class="{open: openIds.includes(job.id)}"></i>
          </div>
          <div class="desc-content" v-show="openIds.includes(job.id)">
            <div class="sub-title">岗位描述：</div>
            {{ job.desc }}
            <div class="sub-title" style="margin-top:8px;">任职要求：</div>
            {{ job.requirement }}
          </div>
        </div>
      </div>

      <div class="empty" v-if="filteredJobs.length === 0">
        暂无匹配的招聘岗位
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabJob",
  data() {
    return {
      selectedSecond: "",
      selectedLocation: "",
      selectedEdu: "",
      openIds: [],
      secondOptions: [
        { label: "武汉港务集团有限公司", value: "武汉港务集团有限公司" },
        { label: "宜昌港务集团有限责任公司", value: "宜昌港务集团有限责任公司" },
        { label: "荆州港务集团有限公司", value: "荆州港务集团有限公司" },
        { label: "武汉港航建设集团有限公司", value: "武汉港航建设集团有限公司" },
        { label: "湖北汉江港航投资有限公司", value: "湖北汉江港航投资有限公司" },
        { label: "华中港航物流集团有限公司", value: "华中港航物流集团有限公司" },
        { label: "湖北港口资本有限公司", value: "湖北港口资本有限公司" },
        { label: "长江数联物流信息（湖北）股份有限公司", value: "长江数联物流信息（湖北）股份有限公司" },
        { label: "湖北长江船舶供应链有限责任公司", value: "湖北长江船舶供应链有限责任公司" }
      ],
      // 新增：工作地点选项（基于现有岗位数据去重整理）
      locationOptions: [
        { label: "武汉市", value: "武汉市" },
        { label: "宜昌市", value: "宜昌市" },
        { label: "荆州市", value: "荆州市" },
        { label: "襄阳市", value: "襄阳市" },
        { label: "宜城市", value: "宜城市" },
        { label: "湖北省内各项目经理部", value: "湖北省内各项目经理部" },
        { label: "国际船舶", value: "国际船舶" }
      ],
      eduOptions: [
        { label: "大专", value: "大专" },
        { label: "本科", value: "本科" },
        { label: "硕士", value: "硕士" }
      ],
      jobList: [
        {
          id: 1,
          name: "市场开发岗",
          secondCompany: "武汉港务集团有限公司",
          third: "",
          dept: "-",
          jobType: "商业运营类",
          needNum: 1,
          education: "本科",
          desc: "1.从事市场开发与客户关系维护、制订市场策略、构建供应链物流链、开展市场及其前景分析等工作；\n2.协助部门开展工作文件起草工作；\n3.在武汉港务集团有限公司下属企业工作。",
          requirement: "1.全日制本科及以上学历，物流管理、管理科学与工程、工商管理等相关专业优先；\n2.具备较好的文字表达能力、沟通协作能力；\n3.身体健康，无违法犯罪记录。",
          location: "武汉市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 2,
          name: "安全环保岗",
          secondCompany: "宜昌港务集团有限责任公司",
          third: "宜昌港务集团有限责任公司枝城港",
          dept: "安全环保部",
          jobType: "安全环保类",
          needNum: 1,
          education: "本科",
          desc: "1.负责公司安全生产、环境保护日常监督管理，落实各项法规及公司制度；\n2.负责现场安全环保巡查、隐患排查整改；\n3.负责组织公司内安全、环保教育培训，以及日常相关台帐整理。",
          requirement: "1.全日制本科及以上学历，环境工程、安全工程等相关专业；\n2.熟悉安全、环保管理相关专业知识；\n3.具备一定的交流沟通能力、分析判断能力及问题处理能力和团队协作能力。",
          location: "宜昌市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 3,
          name: "法务风控岗",
          secondCompany: "宜昌港务集团有限责任公司",
          third: "宜昌港华物流有限公司",
          dept: "多式联运部",
          jobType: "法务风控类",
          needNum: 1,
          education: "本科",
          desc: "1.为公司经营性活动提供法律支持和咨询服务；\n2.负责合同管理和各类文件、协议的合规性审核；\n3.及时跟进和解决各类法律风险和问题。",
          requirement: "1.全日制本科及以上学历，法学等相关专业；\n2.熟悉公司法、合同法等与企业运营相关的法律法规；\n3.具备较好的文字表达能力、沟通协调能力。",
          location: "宜昌市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 4,
          name: "设备管理员",
          secondCompany: "荆州港务集团有限公司",
          third: "荆州港盐卡集装箱有限公司",
          dept: "设备工程部",
          jobType: "设备管理类",
          needNum: 1,
          education: "本科",
          desc: "1.根据需求编制设备、加工件、外购外协件采购计划；\n2.做好生产物资、设备配件的采购协同，管理供应商及采购信息；\n3.统计设备运行及能耗数据，复核物料库存，编制上报数据报表。",
          requirement: "1.全日制本科及以上学历，机械工程、机械设计制造及其自动化等相关专业；\n2.持有相关专业资格证书者优先；\n3.了解港口设备机械与电气相关知识；\n4.具备较好的独立动手能力和解决问题能力。",
          location: "荆州市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 5,
          name: "电气仪表工程师",
          secondCompany: "荆州港务集团有限公司",
          third: "湖北润楚化工储运有限公司",
          dept: "特种设备部",
          jobType: "设备管理类",
          needNum: 1,
          education: "本科",
          desc: "1.负责石化仓储罐区、装卸车、管廊系统工艺运行管控，日常工艺参数监控、巡回检查、台账记录与整理；\n2.参与项目工艺图纸会审、化工工艺设计优化、技改方案编制等。",
          requirement: "1.全日制本科及以上学历，石油工程、油气储运工程、化学工程与工艺、化工设计等相关专业；\n2.熟悉工艺原理或化工设计基础知识，了解行业规范基础标准，能看懂工艺、机制、自控专业图纸，能够熟练使用 CAD、Office 办公软件；\n3.能自觉遵守厂区安全规章制度，能适应倒班工作制，服从现场岗位安排。",
          location: "荆州市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 6,
          name: "设备管理员",
          secondCompany: "荆州港务集团有限公司",
          third: "湖北润楚化工储运有限公司",
          dept: "特种设备部",
          jobType: "设备管理类",
          needNum: 1,
          education: "本科",
          desc: "1.负责设备管理，保障所有设备符合法规及生产运行要求；\n2.建立并完善设备管理台账；\n3.系统执行设备的日常保养、定期检修与故障维修等工作。",
          requirement: "1.全日制本科及以上学历，机械工程、机械电子工程、机械设计制造及其自动化等相关专业；\n2.熟悉工艺原理或化工设计基础知识，熟悉罐区、机泵、管道、阀门及特种设备基本构造与工作原理，了解化工设备日常巡检、维护保养、故障排查及检修基本流程，会识读设备图纸、工艺安装图纸，熟练使用 Office、基础 CAD 办公绘图软件；\n3.能自觉遵守厂区安全规章制度，能适应倒班工作制，服从现场岗位安排。",
          location: "荆州市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 7,
          name: "机械操作工",
          secondCompany: "荆州港务集团有限公司",
          third: "荆州港车阳河港务有限公司",
          dept: "生产控制中心",
          jobType: "港口物流类",
          needNum: 1,
          education: "大专",
          desc: "1.按照安全操作规程，高效完成当班生产任务；\n2.班前查阅交接记录，及时对接处理设备故障；\n3.按设备润滑 “五定” 要求，做好责任区域保养。",
          requirement: "1.全日制大专及以上学历，港口机械与自动控制、电气自动化、工程机械等相关专业优先；\n2.具备与岗位相关的职业资格证书者优先；\n3.态度端正，综合素质强，能快速适应岗位需求；\n4.有相关实习经验者优先。",
          location: "荆州市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 8,
          name: "技术员",
          secondCompany: "武汉港航建设集团有限公司",
          third: "武汉公路桥梁建设集团有限公司",
          dept: "项目经理部",
          jobType: "工程建设类",
          needNum: 6,
          education: "本科",
          desc: "1.参与施工技术方案的编制与技术交底工作；\n2.承担施工现场的技术指导、质量监督与进度管理；\n3.完成工程技术资料的收集整理及施工日志编写等。",
          requirement: "1.全日制本科及以上学历，土木工程、隧道工程、交通工程等相关专业；\n2.具备公路工程或相关施工实习经验者优先；\n3.品德端正，责任心强，积极进取，踏实肯干，具备良好的沟通协调能力；\n4.能够适应并接受项目部驻地工作。",
          location: "湖北省内各项目经理部",
          salary: "7-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 9,
          name: "施工员",
          secondCompany: "武汉港航建设集团有限公司",
          third: "武汉公路桥梁建设集团有限公司",
          dept: "项目经理部",
          jobType: "工程建设类",
          needNum: 1,
          education: "大专",
          desc: "1.负责工程项目现场沥青、水泥、砂石、钢筋材料验收及送检，确保材料规格、质量符合标准及施工规范；\n2.负责现场材料管理与台账建立，参与现场材料盘点、标识及存放管理，及时统计并反馈材料损耗或质量；\n3.做好质保资料归档与信息化录入，维护检测工具及现场材料存放环境。",
          requirement: "1.全日制大专及以上学历，工程管理、建筑学、建筑设计等相关专业优先；\n2.具备工程或施工实习经验者优先；\n3.品德端正，责任心强，积极进取，踏实肯干，具备良好的沟通协调能力；\n4.能够适应并接受偏远地区项目部驻地工作。",
          location: "湖北省内各项目经理部",
          salary: "7-8",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 10,
          name: "航电枢纽信息化岗",
          secondCompany: "湖北汉江港航投资有限公司",
          third: "湖北港口崔家营航电枢纽有限公司/湖北港口雅口航运枢纽有限公司",
          dept: "生产安全部",
          jobType: "技术研发类",
          needNum: 2,
          education: "本科",
          desc: "1.负责水电厂生产管理系统、监控系统、设备状态监测系统、MIS系统、调度通信系统等日常运维、故障处理及通道优化等工作；\n2.负责枢纽计算机网络管理、视频监控系统管理、网络信息安全管理、视频会议系统管理等工作；\n3.负责电厂数字化平台建设，包括数据采集、分析应用，支撑智能运维、故障预警及生产决策优化。",
          requirement: "1.全日制本科及以上学历，计算机科学与技术、软件工程、信息管理与信息系统、网络安全、数据科学与大数据技术、电气工程及其自动化（信息化方向）等相关专业；\n2.具备信息化项目、电厂实习经历或参与过工业控制系统相关课题研究者优先；\n3.熟悉主流数据库，具备数据查询与处理能力，了解网络基（TCP/IP、VLAN、防火墙配置等），了解工业自动化或电力生产流程者优先，具备基本的信息安全防护意识；\n4.具备较好的沟通协作能力。",
          location: "襄阳市/宜城市",
          salary: "8-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 11,
          name: "发电运行岗",
          secondCompany: "湖北汉江港航投资有限公司",
          third: "湖北港口雅口航运枢纽有限公司",
          dept: "发电分公司",
          jobType: "发电运营类",
          needNum: 2,
          education: "本科",
          desc: "1.协助值长调整运行工况，确保设备的经济运行，完成生产计划；\n2.按照定期巡回检查制度定期对所辖主要设备进行巡检，并做好记录；\n3.对所辖设备发现的缺陷及时填写设备缺陷单、汇报、记录，做好防范措施。",
          requirement: "1.全日制本科及以上学历，电气工程及自动化、能源及动力工程(水动)专业或电力院校电力相关专业；\n2.能适应三班倒工作时间，有水电站运行实习经验者优先，持有高压电工证者优先；\n3.具备较强的学习能力和沟通能力，责任心强。",
          location: "宜城市",
          salary: "10-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 12,
          name: "检修岗",
          secondCompany: "湖北汉江港航投资有限公司",
          third: "湖北汉江港航投资有限公司检修分公司",
          dept: "生产调度部",
          jobType: "设备管理类",
          needNum: 1,
          education: "本科",
          desc: "1.负责班组设备技术管理，协助做好班组安全生产工作；\n2.负责分管设备的检修、消缺和日常维护工作，严格执行安全工作规程和工作票制度；\n3.参与设备的改造升级，执行检修工艺规程和检修质量管理标准，落实三级验收制度，提高设备性能和效率。",
          requirement: "1.全日制本科及以上学历，电气工程及自动化、机电一体化、能源与动力工程、机电设备运行与维护、机械工程等相关专业；\n2.具备设备检修实习经验者优先；\n3.具备较强的学习能力和沟通能力，吃苦耐劳，具备较强的敬业精神、钻研精神与抗压能力。",
          location: "襄阳市",
          salary: "10-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 13,
          name: "船舶建造项目岗",
          secondCompany: "华中港航物流集团有限公司",
          third: "武汉大通国际航运有限公司",
          dept: "运营管理部",
          jobType: "港口物流类",
          needNum: 1,
          education: "本科",
          desc: "1.协助船舶建造全流程统筹，制定建造节点计划，跟踪施工进度；\n2.负责推进船体、舾装、机电、涂装等工作，管控建造质量和安全生产，配合船东船检开展报验；\n3.协助对接船级社，处理工程变更、技术答疑及验收对接，把控项目建造成本，完成试航、交船全流程跟进。",
          requirement: "1.全日制本科及以上学历，船舶工程、船舶与海洋工程、轮机工程、船舶电子电气工程等相关专业；\n2.了解《船舶建造规范》《国际海事公约》及国内船舶建造相关法律法规、行业标准，掌握新船建造全流程管理要点；\n3.具备较好的沟通协作能力、项目统筹能力、成本管控意识和抗压能力；\n4.具备船舶建造实习经历者优先。",
          location: "武汉市",
          salary: "7-9",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 14,
          name: "船舶海务专员岗",
          secondCompany: "华中港航物流集团有限公司",
          third: "武汉大通国际航运有限公司",
          dept: "航保安环部",
          jobType: "港口物流类",
          needNum: 1,
          education: "本科",
          desc: "1.协助海务主管开展日常管理，评估船舶安全状态，保障航行安全；\n2.协助开展安全隐患排查整改，处置安全事故及突发事件，协助开展船舶航线规划，制定合理航行方案；\n3.协助引进先进航海设备与技术，提供航海技术支持。",
          requirement: "1.全日制本科及以上学历，船舶驾驶、航海技术等相关专业；\n2.具备海务管理相关实习经历、持有船舶驾驶（三副）适任证书者优先；\n3.熟悉ISM规则及国内海事管理相关法规，具备一定海务实操能力、船舶安全监督能力，能够识别设备故障、操作不规范等隐患；\n4.具备较强的责任心与抗压能力，能够坚守船舶航行安全与合规运营规范。",
          location: "武汉市",
          salary: "7-9",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 15,
          name: "船舶体系专员岗",
          secondCompany: "华中港航物流集团有限公司",
          third: "武汉大通国际航运有限公司",
          dept: "航保安环部",
          jobType: "港口物流类",
          needNum: 1,
          education: "本科",
          desc: "1.协助监督指导岸基部室及船舶SMS体系有效运行，办理DOC、SMC、ISSC、MLC相关证书；\n2.协助制定SMS内审计划、编制检查表，配合开展内审和有效性评价等工作；\n3.协助指定人员组织实施外部审核，保障外审顺利推进，协助整改内外审、各类检查发现的缺陷及船舶险情、不合规等情况。",
          requirement: "1.全日制本科及以上学历，安全工程、应急管理、航运物流等相关专业；\n2.具备船舶安全管理、安全体系管理实习经历者优先；\n3.了解国内外安全管理相关法律法规及行业标准，具备编制安全管理文件的能力；\n4.具备良好的英语听说读写能力、能熟练操作办公软件。",
          location: "武汉市",
          salary: "7-9",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 16,
          name: "高级船员",
          secondCompany: "华中港航物流集团有限公司",
          third: "武汉大通国际航运有限公司",
          dept: "沥青船",
          jobType: "港口物流类",
          needNum: 2,
          education: "本科",
          desc: "1.按照航海法规、公司安全制度及沥青船操作规范，协助船长、轮机长开展航行及机舱作业安全管理，保障船舶运营安全；\n2.负责船舶消防、救生设备日常检查、维护保养及记录，参与安全培训、应急演练；\n3.落实航行值班、气象观测及机舱设备巡检要求，做好运行记录，执行防污染规定，防范环保事故。",
          requirement: "1.全日制本科及以上学历，航海技术、轮机工程、船舶电子电气工程、航运管理、海事管理、交通运输（航运方向）等相关专业；\n2.需持有国际船舶驾驶（三副）或国际轮机管理（三管轮）适任证书；\n3.可与港口、调度团队协作，遇突发情况能快速处置，严守规范保障船、货、人安全；\n4.定期上船工作，拥有较强的责任心与抗压能力，坚守船舶航行安全和船舶机械安全。",
          location: "国际船舶",
          salary: "7-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 17,
          name: "供应链金融事业部业务岗",
          secondCompany: "湖北港口资本有限公司",
          third: "",
          dept: "供应链金融事业部",
          jobType: "资本运作类",
          needNum: 1,
          education: "硕士",
          desc: "1.负责湖北港口集团内、外部企业客户使用供应链金融平台期间的全流程运营管理工作；\n2.负责制定供应链金融平台的业务规划，完成部门供应链金融业务指标；\n3.负责搜集供应链金融平台用户意见，对平台优化和升级出具相关建议；\n4.负责协助供应链金融平台数据库的建设工作。",
          requirement: "1.全日制硕士研究生及以上学历，金融学、经济学、会计学、财务管理等相关专业；\n2.持有证券、银行、基金从业资格者优先；\n3.对金融和港口行业有一定的认识，善于沟通，能适应高强度、快节奏的工作环境，具备较强的团队协作意识。",
          location: "武汉市",
          salary: "8-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 18,
          name: "融资租赁公司业务岗",
          secondCompany: "湖北港口资本有限公司",
          third: "湖北港口融资租赁有限公司",
          dept: "业务部",
          jobType: "资本运作类",
          needNum: 1,
          education: "硕士",
          desc: "1.负责租赁业务的市场开拓、品牌推广与项目办理、资产端及资金端的关系维护；\n2.负责租赁项目前期调查、资料搜集、租赁方案设计，租赁项目立项、业务投放；\n3.负责租赁项目租后管理，资产管理，租金回收，不良资产清收。",
          requirement: "1.全日制硕士研究生及以上学历，金融学、经济学、会计学、财务管理等相关专业；\n2.取得证券、银行、基金从业资格者优先；\n3.对金融和港口行业有一定的认识，善于沟通，能适应高强度、快节奏的工作环境，具备较强的团队协作意识。",
          location: "武汉市",
          salary: "8-12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 19,
          name: "开发工程师",
          secondCompany: "长江数联物流信息（湖北）股份有限公司",
          third: "",
          dept: "研发中心",
          jobType: "技术研发类",
          needNum: 1,
          education: "硕士",
          desc: "1.负责公司物流公共信息平台前后端需求分析、架构设计、代码开发、单元测试及版本迭代，按项目节点完成研发交付，保障系统稳定运行；\n2.参与技术方案论证、技术攻关与难点问题排查，跟进行业前沿技术研究与落地应用；\n3.配合业务、运营部门完成系统需求对接、功能优化、数据接口联调及运维支撑，编写技术文档、接口规范及使用手册等。",
          requirement: "1.全日制硕士研究生及以上学历，计算机科学与技术等相关专业；\n2.持有计算机（中级及以上）资格证书、具备相关知名互联网公司实习经历者优先；\n3.获得技术开发、架构设计项目创新创业奖项优先；\n4.具备较强的代码编写、纠错和架构设计能力，具备较强的学习能力。",
          location: "武汉市",
          salary: "8",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 20,
          name: "数据分析岗",
          secondCompany: "长江数联物流信息（湖北）股份有限公司",
          third: "",
          dept: "物流事业部",
          jobType: "技术研发类",
          needNum: 1,
          education: "本科",
          desc: "1.负责省级平台运营、数据大屏的运维与优化、数据归集、分析及数据产品开发；\n2.负责数据开发、数据分析，挖掘数据价值，进行产品化开发及价值提炼；\n3.提升数据产品交付能力与业务支撑水平。",
          requirement: "1.全日制本科及以上学历，数据科学与大数据技术、计算机等相关专业；\n2.具备相关知名互联网公司实习经历或获得相关数据要素奖项者优先；\n3.逻辑清晰，对数据挖潜较为敏感。",
          location: "武汉市",
          salary: "8",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 21,
          name: "UI设计开发岗",
          secondCompany: "长江数联物流信息（湖北）股份有限公司",
          third: "湖北鲁港云链信息科技有限公司",
          dept: "综合办公室",
          jobType: "技术研发类",
          needNum: 1,
          education: "本科",
          desc: "1.负责软件产品(APP、网页、后台系统)界面视觉设计，输出图标、色彩、版式等符合品牌文化的视觉方案；\n2.配合交互团队将原型转化为高保真视觉稿，解决视觉还原问题，保障设计效果；\n3.参与产品视觉规范制定与维护，优化设计流程，收集用户对视觉体验的反馈，结合行业设计趋势，持续迭代优化界面设计。",
          requirement: "1.全日制本科及以上学历，熟练掌握图形创意、动画编导、原画设计、三维数字建模、数字插画、数字二维动画、动画场景设计、计算机应用等；\n2.能独立完成从需求到落地的视觉设计全流程；\n3.熟练使用PS、SAI2等设计软件，有平面设计经验优先；\n4.有公众号运营或视频剪辑经验，能独立完成内容更新。",
          location: "武汉市",
          salary: "8",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 22,
          name: "技术研发岗",
          secondCompany: "湖北长江船舶供应链有限责任公司",
          third: "",
          dept: "船舶技术部",
          jobType: "技术研发类",
          needNum: 2,
          education: "硕士",
          desc: "1.对接创新中心，负责创新绿色智能船舶能源技术、动力技术、智能技术等关键共性技术研发，形成技术专利；\n2.协助支持标准船型研发，根据示范航线货物、航道等特性，提出不同水域标准化船型研发需求；\n3.跟进船舶三电系统技术动态，参与新设备选型、技术升级、成本优化及供应链平台技术升级，配合项目团队完成船舶三电系统的设计、调试与测试等工作。",
          requirement: "1.全日制硕士研究生及以上学历，船舶与海洋工程、轮机工程、船舶电气工程、电气设计及其自动化、软件工程、信息技术等相关专业；\n2.身体健康，吃苦耐劳，具有较强的学习能力和抗压能力。",
          location: "武汉市",
          salary: "12",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        },
        {
          id: 23,
          name: "行政综合岗",
          secondCompany: "湖北长江船舶供应链有限责任公司",
          third: "",
          dept: "综合管理部",
          jobType: "行政综合类",
          needNum: 1,
          education: "本科",
          desc: "1.负责综合性文稿、规章制度、调研材料等各类材料起草，参与战略研究及政策研究等工作；\n2.负责重大活动、会议、接待的组织协调和保障，参与综合管理与行政服务等工作；\n3.跟踪落实领导批示、会议决议，做好重点工作跟踪督办。",
          requirement: "1.全日制本科及以上学历，行政管理、公共事业管理、公共关系学、法学等相关专业优先；\n2.具有较强的文字写作能力，熟悉公文写作要求，具备较强的政策研究和思辨能力；\n3.通过大学英语六级考试，具备良好的英语表达能力；\n4.能适应高强度工作，自主学习能力较强，有服务意识、大局意识和团队合作精神。",
          location: "武汉市",
          salary: "9-10",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbgk2026"
        }
      ]
    };
  },
  computed: {
    filteredJobs() {
      return this.jobList.filter(job => {
        let isOk = true;
        if (this.selectedSecond) isOk = isOk && job.secondCompany === this.selectedSecond;
        if (this.selectedLocation) isOk = isOk && job.location.includes(this.selectedLocation);
        if (this.selectedEdu) isOk = isOk && job.education === this.selectedEdu;
        return isOk;
      });
    }
  },
  methods: {
    goLink(url) {
      if (url && url !== "#") window.open(url, "_blank");
    },
    toggleDetail(id) {
      const idx = this.openIds.indexOf(id);
      if (idx > -1) this.openIds.splice(idx, 1);
      else this.openIds.push(id);
    }
  }
};
</script>

<style scoped lang="less">
.job-page {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 15px;
  box-sizing: border-box;
}

.select-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.select-box {
  flex-shrink: 0;
  /deep/ .el-select {
    width: 100%;
    min-width: 200px;
    max-width: 260px;
  }
  /deep/ .el-input__inner {
    height: 44px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 15px;
    transition: all 0.2s;
  }
  /deep/ .el-select:hover .el-input__inner {
    border-color: #0056b3;
  }
  /deep/ .el-select:focus .el-input__inner {
    border-color: #0056b3;
    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);
  }
}

.job-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}

.job-item {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 86, 179, 0.06);
  border-left: 4px solid #0056b3;
  transition: transform 0.2s;
  cursor: pointer;
}

.job-item:hover {
  transform: translateY(-3px);
}

.job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 10px;
}

.job-name {
  font-size: 18px;
  font-weight: bold;
  color: #0056b3;
}

.job-company {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.job-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.info-item {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.desc-block {
  margin-top: 8px;
}

.desc-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
}

.arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
  transition: transform 0.2s;
}

.arrow.open {
  transform: rotate(180deg);
}

.desc-content {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
  margin-top: 6px;
}

.salary-line {
  font-size: 16px;
  font-weight: bold;
  color: #ff6600;
  margin-bottom: 8px;
}

.sub-title {
  font-weight: bold;
}

.empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #999;
  padding: 60px 0;
  font-size: 15px;
}

@media (max-width: 768px) {
  .job-page {
    padding: 15px 12px;
  }
  .select-row {
    flex-direction: column;
    align-items: stretch;
  }
  .select-box {
    /deep/ .el-select {
      max-width: 100%;
    }
  }
  .job-list {
    grid-template-columns: 1fr;
  }
  .job-item {
    padding: 18px;
  }
  .job-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  .job-info {
    gap: 10px;
  }
}
</style>